module.exports = __webpack_public_path__ + "static/media/key-necklace-icon-512.00322895.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/key-necklace-icon-512.png
// module id = 598
// module chunks = 0